import { usePreferences } from '@/react-query/usePreferences';

import { OppByTaskTypeChart } from '../../charts/OppByTaskChart';
import { TotalTaskOppChart } from '../../charts/TotalTaskOppChart';
import {
  getOverallHygieneOpportunity,
  getOverallHygieneOpportunityByTask,
} from '../../helpers/hygieneOpportunity';
import type {
  THygienePracticeRates,
  THygieneProviderRates,
  THygieneRegionRates,
} from '../../types';
import { Header } from '../Header';

import { HygieneInsightsTable } from './HygieneInsightsTable';

export const HygieneInsights = ({
  hygieneRates,
  isHygieneLoading,
}: {
  hygieneRates: {
    providerRates: THygieneProviderRates[];
    practiceRates: THygienePracticeRates[];
    regionRates: THygieneRegionRates[];
  };
  isHygieneLoading?: boolean;
}) => {
  const { data: prefs } = usePreferences();

  const hygieneOpportunityByTask = getOverallHygieneOpportunityByTask(
    hygieneRates.practiceRates,
    prefs?.insightsEnabledTasks,
  );

  const totalHygieneOpportunity = getOverallHygieneOpportunity(
    hygieneRates.practiceRates,
    prefs?.insightsEnabledTasks,
  );

  return (
    <div className="vai-flex vai-flex-col vai-gap-4 vai-w-full vai-px-8 vai-py-4">
      <Header />
      <div className="vai-flex vai-flex-row vai-gap-4">
        <TotalTaskOppChart totalOpp={totalHygieneOpportunity} />
        <OppByTaskTypeChart opportunityByTask={hygieneOpportunityByTask} />
      </div>
      <HygieneInsightsTable
        insightsRateData={{
          provider: hygieneRates.providerRates,
          practice: hygieneRates.practiceRates,
          region: hygieneRates.regionRates,
        }}
        isLoading={isHygieneLoading}
      />
    </div>
  );
};
